import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../lib/api'
import { isApex } from '../lib/encontro'

export const useEncontroStore = defineStore('encontro', () => {
  const info = ref(null)
  const loading = ref(false)
  const erro = ref(null)

  async function load() {
    if (isApex()) {
      info.value = null
      return null
    }
    loading.value = true
    erro.value = null
    try {
      const { data } = await api.get('/encontro/info')
      info.value = data.encontro || null
      return info.value
    } catch (err) {
      erro.value = err.response?.data?.message || 'Falha ao carregar encontro'
      info.value = null
      return null
    } finally {
      loading.value = false
    }
  }

  return { info, loading, erro, load }
})
